import React, { useContext } from 'react';
import { TabBar } from 'antd-mobile';
import { useHistory, useLocation, matchPath } from 'react-router-dom';
import {
	SystemQRcodeOutline,
	TextOutline,
	UserOutline
} from 'antd-mobile-icons';

import styled from 'styled-components';
import { matchesPermission } from '../utils/permission-helpers';
import WorkTimeBar from '../components/WorkTimeBar';
import UserSelfContext from '../utils/self-context';

const BottomBar = styled.div`
	flex: 0;
	width: 100%;
	background: #001529;
	color: #fff;
 	border-top: solid 1px var(--adm-color-border);
	.adm-tab-bar-item-active {
		color: #fff;
		background: var(--adm-color-primary);
	}
	.adm-tab-bar-item {
		color: #fff;
	}
`;

const HIDE_MENU = ['/login'];

const pathNamesMap = {
	'/': 'work-orders',
	'/issued-tools': 'tools',
	'/work-orders': 'work-orders',
	'/work-order/*': 'work-orders',
	'/profile': 'profile'
};

const routeMap = {
	'work-orders': '/',
	tools: '/issued-tools',
	profile: '/profile'
};

function Navigation() {
	const { userSelf } = useContext(UserSelfContext);

	const history = useHistory();
	const location = useLocation();
	const { pathname } = location;

	function getMatchingPathKeys() {
		const keys = [];
		Object.keys(pathNamesMap).forEach((key) => {
			const match = matchPath(pathname, {
				path: key,
				exact: true,
				strict: false
			});

			if (match) {
				keys.push(pathNamesMap[key]);
			}
		});

		return keys;
	}

	const tabs = [
		{
			path: '/',
			key: 'work-orders',
			title: 'Work Orders',
			icon: <TextOutline />
		},
		...(matchesPermission(userSelf, 'view_tools') ? [{
			path: '/issued-tools',
			key: 'tools',
			title: 'Tools',
			icon: <SystemQRcodeOutline />
		}] : []),
		{
			path: '/profile',
			key: 'profile',
			title: 'Profile',
			icon: <UserOutline />
		}
	];

	const setRouteActive = (value) => {
		history.push(routeMap[value]);
	};

	return (!HIDE_MENU.includes(pathname) && <BottomBar>
		<WorkTimeBar />
		<TabBar activeKey={getMatchingPathKeys()[0]} onChange={value => setRouteActive(value)}>
			{tabs.map(item => (
				<TabBar.Item key={item.key} icon={item.icon} title={item.title} />
			))}
		</TabBar>
	</BottomBar>);
}

export default Navigation;
